

<template>

   

<div id="maquette_chaussette">
<van-row>

<!-- <img src="@/assets/Lx_M2.png" style="height:80px"/> --> 

<van-col span="9" class="chaussette_gauche_col" >

  <div v-if="StoreCodeRefCoA != 'NU' " class="maquette_text_protection_gauche" v-bind:class="{ opacity_low: !StoreChaussetteChoose}"  >
  {{ $t('Protection côté tirage :') }}
</div>


  <van-image  class="chaussette_img_gauche opacity_low" v-if="!StoreChaussetteChoose"
  fit="cover"
  position="left"
  v-bind:src="StoreChaussetteImgGaucheNoData"
/>


<van-image class="chaussette_img_gauche" v-if="StoreChaussetteChoose && StoreCodeRefCoA != 'NU' "
  fit="cover"
  position="left"
  v-bind:src="StoreChaussetteImgGauche"
/>






</van-col>


<van-col span="6" >
 
</van-col>

<van-col span="9"  class="">

  
<div class="maquette_text_protection_droite" v-bind:class="{ opacity_low: !StoreChaussetteChoose}" >
  {{ $t('Protection :') }}
</div>

  <van-image class="chaussette_img_droite opacity_low" v-if="!StoreChaussetteChoose"
  fit="cover"
  position="left"
  v-bind:src="StoreChaussetteImgDroiteNoData"
/>


  <van-image class="chaussette_img_droite" v-if="StoreChaussetteChoose"
  fit="cover"
  position="left"
  v-bind:src="StoreChaussetteImgDroite"
/>


</van-col>


</van-row>


 </div>



        </template>
        
        
        <script>

        export default {
          components: {

          },
          data() {
            return {
                
            }
          },
          created(){
         
          },
          computed: {
                /** Chausette image */
                StoreChaussetteImgGauche() {
                  return this.globalFunction.existKeyInArray("chaussette", this.$store.state.storeChaussette.chaussette) 
                    ? this.$store.state.storeGlobal.StoreApi + '/images/chaussette/' + this.$store.state.storeChaussette.chaussette.chaussette.imgChaussetteGauche
                    : this.$store.state.storeGlobal.StoreApi + '/images/chaussette/Chaussette_renforcée_côté_tirage.png' 

            
                 },
                StoreChaussetteImgGaucheNoData() {
                  return this.$store.state.storeGlobal.StoreApi + '/images/chaussette/Chaussette_renforcée_côté_tirage.png' 
                 },
            
                StoreChaussetteImgDroite() {
                  return this.globalFunction.existKeyInArray("chaussette", this.$store.state.storeChaussette.chaussette) 
                    ? this.$store.state.storeGlobal.StoreApi + '/images/chaussette/' + this.$store.state.storeChaussette.chaussette.chaussette.imgChaussetteDroite
                    : this.$store.state.storeGlobal.StoreApi + '/images/chaussette/Chaussette_renforcée_côté_non_tirage.png' 

                 },
                   /** Type de connecteur coté A */
                StoreCodeRefCoA() {
                    return this.globalFunction.existKeyInArray("type",  this.$store.state.storeCoA.coA) 
                        ?   this.$store.state.storeCoA.coA.type.TypeCoA
                        :  ''
                },

                 StoreChaussetteImgDroiteNoData() {
                  return this.$store.state.storeGlobal.StoreApi + '/images/chaussette/Chaussette_renforcée_côté_non_tirage.png'
                 },
                  /** Chausette image */
                  StoreChaussetteChoose() {
                    return this.globalFunction.existKeyInArray("chaussette", this.$store.state.storeChaussette.chaussette) 
                    ? true
                    : false 
                 },
          }
        
        
        }
</script>